import React, { useContext } from 'react';
import { faBell, faWrench } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import AppContext from '../../contexts/app-context';

function NavBar({ maxWidth }) {
  const { isAdmin } = useContext(AppContext);

  return (
    <Navbar
      bg='primary'
      variant='dark'
      expand='md'
      collapseOnSelect
      style={{ boxShadow: '1px 1px 4px #9E9E9E', padding: '0.25em 1em' }}
    >
      <Container style={{ maxWidth: maxWidth }}>
        <Navbar.Toggle aria-controls='basic-navbar-nav' />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='mr-auto'>
            <LinkContainer to='/dashboard' data-id='nav_db'>
              <Nav.Link active={false}>Dashboard</Nav.Link>
            </LinkContainer>
            <LinkContainer to='/organizations' data-id='nav_orgs'>
              <Nav.Link active={false}>Organizations</Nav.Link>
            </LinkContainer>
            <LinkContainer to='/accounts' data-id='nav_accts'>
              <Nav.Link active={false}>Accounts</Nav.Link>
            </LinkContainer>
            <LinkContainer to='/reports' data-id='nav_reports'>
              <Nav.Link active={false}>Reports</Nav.Link>
            </LinkContainer>
            <LinkContainer to='/analysis' data-id='nav_analysis'>
              <Nav.Link active={false}>Analysis</Nav.Link>
            </LinkContainer>
            {isAdmin && (
              <LinkContainer to='/admin' data-id='nav_admin'>
                <Nav.Link active={false}>Admin</Nav.Link>
              </LinkContainer>
            )}
          </Nav>

          <Nav>
            <LinkContainer to='/tools' style={{ marginRight: '1em' }}>
              <Nav.Link className='px-0' active={false} data-id='brand_tools'>
                <p className='d-inline mr-2'>Tools</p>
                <FontAwesomeIcon
                  style={{ fontSize: '20px', verticalAlign: 'sub' }}
                  icon={faWrench}
                />
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to='/alerts'>
              <Nav.Link className='px-0' active={false} data-id='brand_alerts'>
                <p className='d-inline mr-2'>Alerts</p>
                <FontAwesomeIcon
                  style={{ fontSize: '20px', verticalAlign: 'sub' }}
                  icon={faBell}
                />
              </Nav.Link>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
